import React, { useState } from 'react';
import { 
  FaCalendarAlt,
  FaClock,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaGraduationCap,
  FaUniversity,
  FaBriefcase,
  FaCheckCircle,
  FaArrowLeft,
  FaArrowRight,
  FaMapMarkerAlt,
  FaVenusMars,
  FaBook,
  FaLaptopCode
} from 'react-icons/fa';

const ConsultationBooking = () => {
  // Replace with your Google Apps Script URL
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyZwpn9YONB_NvfjLwBRFlfz9I2h6PWmsFj3sE2srCEqfokMqILfcpCJXY04d9ylvd3ZQ/exec'

  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    gender: '',
    dateOfBirth: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    college: '',
    department: '',
    graduationYear: '',
    currentYear: '',
    courseInterest: '',
    experience: '',
    hasInternshipExperience: '',
    interestedInInternship: '',
    projectInterest: '',
    conferenceInterest: '',
    preferredMode: '',
    additionalInfo: ''
  });

  const courses = [
    'Class 6-10 Foundation',
    'IIT-JEE Preparation',
    'NEET Preparation',
    'CA (Chartered Accountancy)',
    'GATE Preparation',
    'GRE/GMAT (Abroad Exams)',
    'IELTS/TOEFL',
    'Web Development',
    'Data Science & AI',
    'Machine Learning',
    'Mobile App Development',
    'Cloud Computing',
    'Cyber Security',
    'Full Stack Development',
    'DevOps Engineering',
    'Blockchain Technology',
    'Digital Marketing',
    'Graphic Design & UI/UX',
    'Business Analytics',
    'Python Programming',
    'Java Programming',
    'Other'
  ];

  const timeSlots = [
    '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM',
    '12:00 PM', '12:30 PM', '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM',
    '04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM',
    '07:00 PM', '07:30 PM'
  ];

  const currentYear = new Date().getFullYear();
  const graduationYears = Array.from({ length: 10 }, (_, i) => currentYear + i - 5);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const generateCalendar = () => {
    const today = new Date();
    const dates = [];
    for (let i = 0; i < 29; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-IN', { 
      weekday: 'short', 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };

  const validateStep1 = () => {
    if (!selectedDate || !selectedTime) {
      alert('Please select both date and time');
      return false;
    }
    return true;
  };

  const validateStep2 = () => {
    const required = [
      'firstName', 'lastName', 'email', 'phone', 'gender',
      'college', 'department', 'graduationYear', 'courseInterest'
    ];
    
    for (let field of required) {
      if (!formData[field]) {
        alert('Please fill all required fields');
        return false;
      }
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return false;
    }

    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(formData.phone)) {
      alert('Please enter a valid 10-digit mobile number');
      return false;
    }

    return true;
  };

  const handleNextStep = () => {
    if (step === 1 && validateStep1()) {
      setStep(2);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBackStep = () => {
    setStep(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async () => {
    if (!validateStep2()) return;

    setSubmitting(true);

    try {
      const bookingData = {
        action: 'addConsultation',
        ...formData,
        consultationDate: formatDate(selectedDate),
        consultationTime: selectedTime,
        bookingTimestamp: Date.now(),
        bookingDate: new Date().toLocaleDateString('en-IN'),
        status: 'Pending'
      };

      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData)
      });

      setConfirmed(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      alert('Failed to book consultation. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (confirmed) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container my-5 py-5">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card border-0 shadow-lg">
                <div className="card-body text-center ">
                  <div className="mb-2">
                    <div style={{ fontSize: '3rem', color: '#28a745' }}>
                      <FaCheckCircle />
                    </div>
                  </div>
                  <h2 className="h3 mb-2">Booking Confirmed .....!</h2>
                  <p className="fs-6 fw-bold text-body-tertiary mb-3">Your Free Course Consultation booking is confirmed with Olewin Academy.</p>
                  <p className="mb-2">An invitation has been emailed to you. <span className='text-primary fw-bold'>Visit yout mail for More Info...</span> </p>
                  
                  <div className="bg-light rounded p-2 my-3">
                    <h3 className="h5 mb-3">{formatDate(selectedDate)}</h3>
                    <h4 className="h4 text-primary">{selectedTime}</h4>
                    <p className="mb-0 mt-3">
                      <strong>Course:</strong> {formData.courseInterest}
                    </p>
                  </div>

                  <div className="alert alert-info">
                    <small>
                      <strong>What's Next?</strong><br />
                      Our counselor will contact you on {formData.phone} to confirm your session.
                      You'll receive a Google Meet link via email.
                    </small>
                  </div>

                  <button 
                    className="btn btn-success btn-lg mt-1"
                    onClick={() => window.location.reload()}
                  >
                    Book Another Consultation
                  </button>
                <p className="mt-2 px-3 ">Contact us: - +91 8639449423 <span className='text-primary '> Email:- <a href="mailto:olewinacademy@gmail.com">olewinacademy@gmail.com</a></span> </p>

                </div>
              </div>
            </div>
          </div>
        </div>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
      </div>
    );
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Progress Bar */}
      <div className="bg-white border-bottom py-5 my-5">
        <div className="container">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center">
              <div className={`rounded-circle d-flex align-items-center justify-content-center ${step >= 1 ? 'bg-success text-white' : 'bg-light'}`}
                   style={{ width: '40px', height: '40px' }}>
                {step > 1 ? <FaCheckCircle /> : '1'}
              </div>
              <div className="text-center ms-2 me-4">
                <small className="d-block fw-semibold">CHOOSE TIME</small>
              </div>
            </div>
            
            <div style={{ width: '100px', height: '2px', backgroundColor: step === 2 ? '#58A95B' : '#dee2e6' }}></div>
            
            <div className="d-flex align-items-center ms-4">
              <div className={`rounded-circle d-flex align-items-center justify-content-center ${step === 2 ? 'bg-primary text-white' : 'bg-light'}`}
                   style={{ width: '40px', height: '40px' }}>
                {step === 2 ? '2' : '2'}
              </div>
              <div className="text-center ms-2">
                <small className="d-block fw-semibold">YOUR INFO</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="bg-primary text-white py-5 my-1">
        <div className="container text-center">
        <h1 className="h2 mb-2">Request a Free Consultation</h1>
        <p className="mb-1">Book your personalized course counseling session with Olewin Academy.</p>
        <p className="mb-2">Schedule your one-on-one session today.</p>

        </div>
      </div>

      <div className="container py-4">
        {step === 1 ? (
          <div className="row">
            <div className="col-lg-7">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  <h3 className="h5 mb-4">
                    <FaCalendarAlt className="me-2 text-primary" />
                    Select a Date
                  </h3>
                  
                  <div className="row g-2">
                    {generateCalendar().map((date, index) => (
                      <div key={index} className="col-6 col-md-4 col-lg-2">
                        <button
                          className={`btn w-100 btn-sm ${selectedDate?.toDateString() === date.toDateString() ? 'btn-primary' : 'btn-outline-success'}`}
                          onClick={() => handleDateSelect(date)}
                        >
                          <small className="d-block fw-bold ">{date.toLocaleDateString('en-IN', { weekday: 'short' })}</small>
                          <strong>{date.getDate()}</strong>
                          <small className="d-block fw-bold ">{date.toLocaleDateString('en-IN', { month: 'short' })}</small>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-6 col-sm-12 mt-4 mt-lg-0 position-relative">
              <div className="card border-0 shadow-md " style={{ top: '20px' }}>
                <div className="card-body p-4">
                  <h3 className="h5 mb-4">
                    <FaClock className="me-2 text-dark" />
                    Select Time Slot
                  </h3>
                  
                  {selectedDate ? (
                    <>
                      <p className="text-muted mb-3">
                        <small>Showing times for {formatDate(selectedDate)}</small>
                      </p>
                      
                      <div className="d-flex gap-3" style={{ maxHeight:'400px',  overflowX: 'auto' }}>
                        {timeSlots.map((time, index) => (
                          <button
                            key={index}
                            className={`btn ${selectedTime === time ? 'btn-dark' : 'btn-outline-success'}`}
                            onClick={() => handleTimeSelect(time)}
                          >
                            {time}
                          </button>
                        ))}
                      </div>

                      <button 
                        className="btn btn-success btn-lg  text-white fw-bolder w-100 mt-4"
                        onClick={handleNextStep}
                        disabled={!selectedTime}
                      >
                        Continue <FaArrowRight className="ms-2" />
                      </button>
                    </>
                  ) : (
                    <div className="text-center text-muted py-5">
                      <FaCalendarAlt style={{ fontSize: '3rem', opacity: 0.3 }} />
                      <p className="mt-3">Please select a date first</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-md-5">
                  <h2 className="h4 mb-2">Your Information</h2>
                  <div className="mb-4">
                    <strong>{formatDate(selectedDate)} {selectedTime}</strong>
                    <button className="btn btn-link btn-sm text-decoration-none" onClick={handleBackStep}>
                      Edit
                    </button>
                  </div>

                  <div className="row g-3">
                    {/* Personal Information */}
                    <div className="col-12"><h5 className="border-bottom pb-2 mb-3">Personal Details</h5></div>
                    
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaUser className="me-2" />First Name <span className="text-danger">*</span>
                      </label>
                      <input type="text" className="form-control" name="firstName" value={formData.firstName} onChange={handleInputChange} placeholder="Enter first name" />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Last Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name="lastName" value={formData.lastName} onChange={handleInputChange} placeholder="Enter last name" />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaEnvelope className="me-2" />Email Address <span className="text-danger">*</span>
                      </label>
                      <input type="email" className="form-control" name="email" value={formData.email} onChange={handleInputChange} placeholder="your.email@example.com" />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaPhone className="me-2" />Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input type="tel" className="form-control" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="10-digit mobile number" maxLength="10" />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaVenusMars className="me-2" />Gender <span className="text-danger">*</span>
                      </label>
                      <select className="form-select" name="gender" value={formData.gender} onChange={handleInputChange}>
                        <option value="">Select gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Date of Birth</label>
                      <input type="date" className="form-control" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleInputChange} />
                    </div>

                    {/* Address */}
                    <div className="col-12"><h5 className="border-bottom pb-2 mb-3 mt-3">Address Information</h5></div>

                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        <FaMapMarkerAlt className="me-2" />Address
                      </label>
                      <input type="text" className="form-control" name="address" value={formData.address} onChange={handleInputChange} placeholder="Street address" />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-semibold">City</label>
                      <input type="text" className="form-control" name="city" value={formData.city} onChange={handleInputChange} placeholder="City" />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-semibold">State</label>
                      <input type="text" className="form-control" name="state" value={formData.state} onChange={handleInputChange} placeholder="State" />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Pincode</label>
                      <input type="text" className="form-control" name="pincode" value={formData.pincode} onChange={handleInputChange} placeholder="Pincode" maxLength="6" />
                    </div>

                    {/* Academic Information */}
                    <div className="col-12"><h5 className="border-bottom pb-2 mb-3 mt-3">Academic Details</h5></div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaUniversity className="me-2" />College/University/Institute <span className="text-danger">*</span>
                      </label>
                      <input type="text" className="form-control" name="college" value={formData.college} onChange={handleInputChange} placeholder="Institution name" />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Department/Stream <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name="department" value={formData.department} onChange={handleInputChange} placeholder="e.g., Computer Science, Commerce" />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaGraduationCap className="me-2" />Expected Graduation Year <span className="text-danger">*</span>
                      </label>
                      <select className="form-select" name="graduationYear" value={formData.graduationYear} onChange={handleInputChange}>
                        <option value="">Select year</option>
                        {graduationYears.map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Current Year of Study</label>
                      <select className="form-select" name="currentYear" value={formData.currentYear} onChange={handleInputChange}>
                        <option value="">Select year</option>
                        <option value="1st Year">1st Year</option>
                        <option value="2nd Year">2nd Year</option>
                        <option value="3rd Year">3rd Year</option>
                        <option value="4th Year">4th Year</option>
                        <option value="Final Year">Final Year</option>
                        <option value="Graduated">Graduated</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    {/* Course Interest */}
                    <div className="col-12"><h5 className="border-bottom pb-2 mb-3 mt-3">Program Interest</h5></div>

                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        <FaBook className="me-2" />Course/Program Interest <span className="text-danger">*</span>
                      </label>
                      <select className="form-select" name="courseInterest" value={formData.courseInterest} onChange={handleInputChange}>
                        <option value="">Select course</option>
                        {courses.map(course => (
                          <option key={course} value={course}>{course}</option>
                        ))}
                      </select>
                    </div>

                    {/* Experience & Interests */}
                    <div className="col-12"><h5 className="border-bottom pb-2 mb-3 mt-3">Experience & Interests</h5></div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaBriefcase className="me-2" />Work Experience
                      </label>
                      <select className="form-select" name="experience" value={formData.experience} onChange={handleInputChange}>
                        <option value="">Select experience</option>
                        <option value="No Experience">No Experience</option>
                        <option value="Less than 1 year">Less than 1 year</option>
                        <option value="1-2 years">1-2 years</option>
                        <option value="2-5 years">2-5 years</option>
                        <option value="5+ years">5+ years</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Previous Internship Experience?</label>
                      <select className="form-select" name="hasInternshipExperience" value={formData.hasInternshipExperience} onChange={handleInputChange}>
                        <option value="">Select option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        <FaLaptopCode className="me-2" />Interested in Paid Internship?
                      </label>
                      <select className="form-select" name="interestedInInternship" value={formData.interestedInInternship} onChange={handleInputChange}>
                        <option value="">Select option</option>
                        <option value="Yes - Immediate">Yes - Looking immediately</option>
                        <option value="Yes - Future">Yes - In future</option>
                        <option value="Maybe">Maybe</option>
                        <option value="No">No</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Interested in Real-Time Projects?</label>
                      <select className="form-select" name="projectInterest" value={formData.projectInterest} onChange={handleInputChange}>
                        <option value="">Select option</option>
                        <option value="Yes">Yes</option>
                        <option value="Maybe">Maybe</option>
                        <option value="No">No</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">International Conference Presentation?</label>
                      <select className="form-select" name="conferenceInterest" value={formData.conferenceInterest} onChange={handleInputChange}>
                        <option value="">Select option</option>
                        <option value="Very Interested">Very Interested</option>
                        <option value="Interested">Interested</option>
                        <option value="Maybe">Maybe</option>
                        <option value="Not Interested">Not Interested</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Preferred Mode of Consultation</label>
                      <select className="form-select" name="preferredMode" value={formData.preferredMode} onChange={handleInputChange}>
                        <option value="">Select mode</option>
                        <option value="Video Call (Zoom/Meet)">Video Call (Google Meet/ WhatsApp )</option>
                        <option value="Phone Call">Phone Call(Voice)</option>
                        <option value="email Call">Send Email of Courses/Program (if available)</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label fw-semibold">Additional Information</label>
                      <textarea className="form-control" name="additionalInfo" value={formData.additionalInfo} onChange={handleInputChange} rows="4" 
                        placeholder="Tell us more about your goals, questions, or specific areas you'd like to discuss..."></textarea>
                    </div>

                    {/* Action Buttons */}
                    <div className="col-12 mt-4">
                      <div className="d-flex justify-content-between">
                        <button className="btn btn-outline-secondary btn-lg" onClick={handleBackStep} disabled={submitting}>
                          <FaArrowLeft className="me-2" /> Back
                        </button>
                        <button className="btn btn-primary btn-lg" onClick={handleSubmit} disabled={submitting}>
                          {submitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Confirming...
                            </>
                          ) : (
                            <>Confirm Booking</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
    </div>
  );
};

export default ConsultationBooking;